import { appConfig } from "~/config/appConfig";

export const authScopeConfig = (): Record<string, string[]> => {
    return {
        [appConfig().graphApiBase]: [appConfig().graphApiScope],
        [`${appConfig().apixApiBase}/v1/webrequest/invoke`]: [appConfig().apixApiScope],
    };
};
